import './itens.css';
import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { ApiError } from '../../../services/tipos';
import { useAppSelector } from '../../../store/hooks';
import Spinner from '../../../rxlib/components/spinner';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import { ConfiguracoesTabela, Table } from '../../../rxlib/components/table';

interface ConsultaLicencaOrganizacaoItensProps {
    show: boolean;
    onHide: () => void;
    idLicencaOrganizacao: string;
}

function ConsultaLicencaOrganizacaoItens(props: ConsultaLicencaOrganizacaoItensProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [itensLicencaOrganizacao, setItensLicencaOrganizacao] = useState<[{}]>([{}]);

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Nome', campo: 'nome', entidadePai: 'itemLicenca', tipo: 'string' },
            { nome: 'Chave', campo: 'chave', entidadePai: 'itemLicenca', tipo: 'string' },
            { nome: 'Tipo de controle', campo: 'tipoControle', entidadePai: 'itemLicenca', tipo: 'tipoControle' },
            { nome: 'Valor', campo: 'valorItem', tipo: 'string' },
        ],
    }

    const temPermissao = usuarioTemPermissao(token, 'itens_licenca_organizacao_visualizar');

    const handleHideWarning = () => setShowWarning(false);

    useEffect(() => {
        if (temPermissao) {
            if (props.idLicencaOrganizacao) {
                setCarregando(true);
                api.get(`/ItemLicencaOrganizacao/PorIdLicencaOrganizacao/${props.idLicencaOrganizacao}`)
                    .then(response => {
                        setTimeout(() => {
                            setItensLicencaOrganizacao(response.data);
                            setCarregando(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        setCarregando(false);
                        setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                        setShowWarning(true);
                    });
            }
        }
    }, [props, temPermissao]);

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} dialogClassName='naja-modal-licenca-organizacao-itens' centered>
                <Modal.Body className='naja-modal-body-licenca-organizacao-itens'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-11'>
                                <h6>Itens da licença</h6>
                            </div>
                            <div className='col-1 naja-btn-close-cell-licenca-organizacao-itens'>
                                <button type='button' className='btn-close' aria-label='Close' onClick={props.onHide} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                {
                                    carregando
                                        ? <Spinner
                                            classStyle='rxlib-spinner'
                                            classNameSpinner='mt-4 mb-4' />
                                        : <Table
                                            campoId='id'
                                            tableDetalhe={false}
                                            tipoBotaoAcao='button'
                                            acoesPersonalizadas={[]}
                                            configuracoes={configuracoesTabela}
                                            fonteDados={itensLicencaOrganizacao} />
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ModalWarning
                show={showWarning}
                message={messageWarning}
                onHide={handleHideWarning} />
        </>
    );
}

export default ConsultaLicencaOrganizacaoItens;